import { Lightning as lng } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { Dropdown } from './Dropdown';
import { Button } from '../../../components/shared/Button';
import { ScreenSize } from '../../../api/ScreenSize';
import { CheckBox } from './CheckBox';
import { SubscriptionTypes } from '../../../Business/detail/actions/epgRecordingActions/SubscriptionSettings.types';

const _constants = {
  spacing: 10,
  w: 880,
  buttonsTop: 580,
  buttonWidth: ScreenSize.w / 3 / 2,
  buttonsMargin: 32,
};

export class CreateEditRecordingDialog extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: 0xdd070707,
      rect: true,
      Content: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        flex: { direction: 'column', alignItems: 'center' },
        Label: {
          w: _constants.w,
          text: {
            text: 'Option title',
            ...Theme.Fonts.Option.Title,
            color: Theme.Colors.Option.Text.Normal,
          },
        },
        ItemList: {
          flex: { direction: 'column' },
          Type: {
            w: _constants.w,
            flexItem: { marginTop: _constants.spacing },
            type: Dropdown,
          },
          Begin: {
            w: _constants.w,
            flexItem: { marginTop: _constants.spacing },
            type: Dropdown,
          },
          End: {
            w: _constants.w,
            flexItem: { marginTop: _constants.spacing },
            type: Dropdown,
          },
          Protected: {
            w: _constants.w,
            flexItem: { marginTop: _constants.spacing },
            type: CheckBox,
          },
        },
        Buttons: {
          flexItem: { marginTop: _constants.spacing * 2 },
          w: _constants.buttonWidth * 2 + _constants.buttonsMargin * 2,
          Cancel: {
            type: Button,
            buttonMode: 'dialog',
            w: _constants.buttonWidth,
            signals: {
              onActivate: '_handleCancel',
            },
          },
          Confirm: {
            x: _constants.buttonWidth + _constants.buttonsMargin,
            type: Button,
            buttonMode: 'dialog',
            w: _constants.buttonWidth,
            signals: {
              onActivate: '_handleConfirm',
            },
          },
        },
      },
    };
  }

  _init() {
    this.focusList = [...this.tag('ItemList').children.filter(child => child.visible), this.tag('Buttons')];
    this.focusListX = [...this.tag('Buttons').children];
    this.focusY = 0;
    this.focusX = 1;
  }

  updateSettings() {
    let typeDropDown = this.tag('Type');
    typeDropDown.title = this._settings.titles.typeTitle;
    typeDropDown.items = this._settings.subscriptionTypes;
    typeDropDown.selected = this._settings.defaultTypeIndex;
    typeDropDown.signals = {};
    typeDropDown.signals.valueChanged = (value, _idx) => {
      switch (value.value) {
        case 'program':
          this._settings.type = SubscriptionTypes.PROGRAM;
          break;
        case 'season':
          this._settings.type = SubscriptionTypes.SEASON;
          break;
        case 'series':
          this._settings.type = SubscriptionTypes.SERIES;
          break;
      }
    };

    let begin = this.tag('Begin');
    begin.title = this._settings.titles.beginBufferTitle;
    begin.items = this._settings.beginBufferOptions;
    begin.selected = this._settings.defaultBeginIndex;
    begin.signals = {};
    begin.signals.valueChanged = (value, _idx) => {
      this._settings.beginBuffer = +value.value;
    };

    let end = this.tag('End');
    end.title = this._settings.titles.endBufferTitle;
    end.items = this._settings.endBufferOptions;
    end.selected = this._settings.defaultEndIndex;
    end.signals = {};
    end.signals.valueChanged = (value, _idx) => {
      this._settings.endBuffer = +value.value;
    };

    let protectedRec = this.tag('Protected');
    protectedRec.label = this._settings.titles.deleteProtectTitle;
    protectedRec.value = this._settings.deleteProtected;
    protectedRec.signals = {};
    protectedRec.signals.valueChanged = value => {
      this._settings.deleteProtected = value;
    };
  }

  set showTypeOption(val) {
    this.tag('Type').visible = val;
  }

  set showBufferOptions(val) {
    this.tag('Begin').visible = val;
    this.tag('End').visible = val;
  }

  _handleConfirm() {
    this.fireAncestors('$closeDialog');
    this._onSucc && this._onSucc(this._settings);
  }

  _handleCancel() {
    this.fireAncestors('$closeDialog');
    this._onCan && this._onCan();
  }

  updateTitleLabel() {
    const labelTag = this.tag('Label');
    if (labelTag) {
      const textTexture = labelTag.text;
      if (textTexture) {
        textTexture.text = this.titleLabelContent.record + ' ' + this.titleLabelContent.program;
      } else {
        throw 'Error Text texture doesnt exist';
      }
    } else {
      throw 'Error LabelTag is not defined';
    }
  }

  set title(val) {
    if (!this.titleLabelContent) this.titleLabelContent = {};
    this.titleLabelContent.record = val;
    this.updateTitleLabel();
  }

  set recordingTitle(val) {
    if (!this.titleLabelContent) this.titleLabelContent = {};
    this.titleLabelContent.program = val;
    this.updateTitleLabel();
  }

  set subscriptionSettings(val) {
    /** @type {SubscriptionSettings} */
    this._settings = val;
    this.updateSettings();
  }

  set onSuccess(val) {
    this._onSucc = val;
  }

  set onCancel(val) {
    this._onCan = val;
  }

  set buttons(val) {
    this.tag('Cancel').label = val.cancel;
    this.tag('Confirm').label = val.confirm;
  }

  _getFocused() {
    if (this._onButtons()) return this.focusListX[this.focusX];
    return this.focusList[this.focusY];
  }

  _handleRight() {
    if (!this._onButtons()) return;
    let prevValue = this.focusX;
    this.focusX = Math.min(this.focusX + 1, this.focusListX.length - 1);
    return prevValue !== this.focusX;
  }

  _handleLeft() {
    if (!this._onButtons()) return;
    let prevValue = this.focusX;
    this.focusX = Math.max(this.focusX - 1, 0);
    return prevValue !== this.focusX;
  }

  _handleDown() {
    let prevValue = this.focusY;
    this.focusY = Math.min(this.focusY + 1, this.focusList.length - 1);
    return prevValue !== this.focusY;
  }

  _handleUp() {
    let prevValue = this.focusY;
    this.focusY = Math.max(this.focusY - 1, 0);
    return prevValue !== this.focusY;
  }

  _onButtons() {
    return this.focusList[this.focusY] === this.tag('Buttons');
  }

  _handleBack() {
    this.fireAncestors('$closeDialog');
    return true;
  }
}
